export default __webpack_public_path__ + "static/media/gov_ro.750ffe20.png";